'use client';

import { getClientApplicationConfig } from '@hc-frontend/core-context';
import Script from 'next/script';

export function FullstoryScript() {
  const config = getClientApplicationConfig();

  const env = config.core.appEnvironment;

  if (env !== 'prd') {
    return null;
  }

  return (
    <Script
      id="load-fullstory-script"
      data-testid="load-fullstory-script"
      strategy="afterInteractive"
    >
      {`window._fs_host="fullstory.com",window._fs_script="edge.fullstory.com/s/fs.js",window._fs_org="o-1Q8ZNW-na1",window._fs_namespace="FS",function(n,e,t,o,s,c,i,f){if(t in n){n.console&&n.console.log&&n.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');return}(i=n[t]=function(n,e,t){i.q?i.q.push([n,e,t]):i._api(n,e,t)}).q=[],(c=e.createElement(o)).async=1,c.crossOrigin="anonymous",c.src="https://"+_fs_script,(f=e.getElementsByTagName(o)[0]).parentNode.insertBefore(c,f),i.identify=function(n,e,t){i(s,{uid:n},t),e&&i(s,e,t)},i.setUserVars=function(n,e){i(s,n,e)},i.event=function(n,e,t){i("event",{n:n,p:e},t)},i.anonymize=function(){i.identify(!1)},i.shutdown=function(){i("rec",!1)},i.restart=function(){i("rec",!0)},i.log=function(n,e){i("log",[n,e])},i.consent=function(n){i("consent",!arguments.length||n)},i.identifyAccount=function(n,e){c="account",(e=e||{}).acctId=n,i(c,e)},i.clearUserCookie=function(){},i.setVars=function(n,e){i("setVars",[n,e])},i._w={},f="XMLHttpRequest",i._w[f]=n[f],f="fetch",i._w[f]=n[f],n[f]&&(n[f]=function(){return i._w[f].apply(this,arguments)}),i._v="1.3.0"}(window,document,window._fs_namespace,"script","user");`}
    </Script>
  );
}
